import { SET_WEBSHOP_INFO_CONFIG, SET_WEBSHOP_APP_CONFIG } from '../../actionTypes/webshopinfo'

const initialState = {
	config: null,
	appConfig: null,
}

export function webshopInfoReducer (state = initialState, action) {
	switch (action.type) {
		case SET_WEBSHOP_INFO_CONFIG:
			return {
				...state,
				config: action.value,
			}
		case SET_WEBSHOP_APP_CONFIG:
			return {
				...state,
				appConfig: action.value
			}
		default:
			return state
	}
}
